import React, { useEffect } from "react";
import { GoogleLogin } from "@react-oauth/google";
import { useNavigate, useLocation } from "react-router-dom";
import queryString from "query-string";
import { useCurrentUser } from "../../hooks/currentUser";
import {
  Card,
  Center,
  Container,
  Text,
  Title,
  Grid,
  LoadingOverlay,
} from "@mantine/core";
import { notifications } from "@mantine/notifications";
import "./login.css";

export default () => {
  const { currentUser, loginUser } = useCurrentUser();
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (currentUser?.isAuth) {
      navigate(queryString.parse(location.search)?.referer || "/");
    }
  }, [currentUser?.isAuth]);

  return (
    <Container fluid px="xs" mt="xs" pt="xs" style={{ width: "100%" }}>
      <Center style={{ minHeight: "50vh" }}>
        <Card
          shadow="sm"
          padding="lg"
          radius="md"
          withBorder
          style={{ textAlign: "center", width: "30%" }}
        >
          <Card.Section withBorder inheritPadding py="xs">
            <Title order={2}>Welcome Adventurer</Title>
          </Card.Section>
          <Card.Section withBorder inheritPadding py="xs">
            <Title order={5}>Login to your Account</Title>
            <Grid justify="center" mt="lg">
              <Grid.Col
                span={12}
                md={6}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <GoogleLogin
                  onSuccess={(credentialResponse) => {
                    loginUser(credentialResponse);
                    notifications.show({
                      message: "Login Successful",
                      color: "green",
                    });
                  }}
                  onFailure={() => {
                    console.log("Login Failed");
                    notifications.show({
                      message: "Login Failed",
                      color: "red",
                    });
                  }}
                />
              </Grid.Col>
            </Grid>
          </Card.Section>
        </Card>
      </Center>
    </Container>
  );
};
